export const FIREBASE_STORAGE_URL = import.meta.env.VITE_STORAGE_URL
export const FIREBASE_FUNCTION_URL = import.meta.env.VITE_FUNCTION_URL